// @ts-strict-ignore
import { useEffect, useRef } from 'react';
import { useAppSelector } from '~/store/reduxHooks';
import { selectNodeAtSearchMatchIndex } from 'flow/store/redux/selectors';
import { usePanReactFlowToNode } from '../hooks';

/**
 * Controller component that deals with the auto-pan logic on search match changes.
 * Renders nothing, and isolates behavior
 * @returns null
 */
export default function SearchMatchViewportController() {
  const nodeAtSearchMatchIndex = useAppSelector(selectNodeAtSearchMatchIndex);

  const prevNodeIdAtSearchMatchIndex = useRef<string>(null);
  const panViewportToNode = usePanReactFlowToNode();

  useEffect(() => {
    if (!nodeAtSearchMatchIndex) {
      return;
    }

    /**
     * a new canvas rect object is created when the user pans manually so manually panning triggers
     * the effect. this check prevents the auto-pan from happening more than once for a given
     * search matched node, allowing the user to manually pan around *and* use auto-pan
     */
    if (prevNodeIdAtSearchMatchIndex.current === nodeAtSearchMatchIndex.id) {
      return;
    }

    prevNodeIdAtSearchMatchIndex.current = nodeAtSearchMatchIndex.id;

    panViewportToNode(nodeAtSearchMatchIndex);
  }, [
    nodeAtSearchMatchIndex, panViewportToNode,
  ]);

  // controller component - handles business logic without rendering anything
  return null;
}
